import React from "react";

export function CalcTransactionres(res) {
  console.log(res);
  return res?.data?.data?.TransactionRecord?.reduce(
    (acc, item) => {
      item?.consultation_id?.forEach((consultation) => {
        console.log(consultation);
        const consType = consultation.consType.toLowerCase(); // Virtual or InPerson
        const specialization = item.Specalaization?.[0]?.name; // Get specialization name

        if (!specialization) return; // Skip if no specialization

        if (consType === 'inperson') {
          acc.inPerson.total += 1; // Increment total in-person count

          if (!acc.inPerson.specializations[specialization]) {
            acc.inPerson.specializations[specialization] = 0;
          }
          acc.inPerson.specializations[specialization] += 1;
        } else if (consType === 'virtual') {
          acc.virtual.total += 1; // Increment total virtual count

          if (!acc.virtual.specializations[specialization]) {
            acc.virtual.specializations[specialization] = 0;
          }
          acc.virtual.specializations[specialization] += 1;
        }
      });

      return acc;
    },
    {
      inPerson: { total: 0, specializations: {} },
      virtual: { total: 0, specializations: {} },
    }
  );
}

export function CalcPendingDueRecords(res) {
  return res?.data?.data?.PendingDueRecords[0]?.Transaction?.reduce(
    (acc, item) => {
      item.consultation_id.forEach((consultation) => {
        const consType = consultation.consType.toLowerCase(); // Virtual or InPerson
        const specialization = item.Specalaization[0]?.name; // Get specialization name

        if (!specialization) return; // Skip if no specialization

        if (consType === 'inperson') {
          acc.inPerson.total += 1; // Increment total in-person count

          if (!acc.inPerson.specializations[specialization]) {
            acc.inPerson.specializations[specialization] = 0;
          }
          acc.inPerson.specializations[specialization] += 1; // Increment specialization count for in-person
        } else if (consType === 'virtual') {
          acc.virtual.total += 1; // Increment total virtual count

          if (!acc.virtual.specializations[specialization]) {
            acc.virtual.specializations[specialization] = 0;
          }
          acc.virtual.specializations[specialization] += 1; // Increment specialization count for virtual
        }
      });

      return acc;
    },
    {
      inPerson: { total: 0, specializations: {} }, // Structure for inPerson
      virtual: { total: 0, specializations: {} }, // Structure for virtual
    }
  );
}
